<template>
<div></div>
</template>

<script>
export default {
  name: "HonorsPage"
}
</script>

<style scoped>

</style>
